import React, { useContext } from 'react';
import Head from 'next/head';

import { MarketContext } from 'providers/market';
import { WEBSITE_CDN } from 'utils/config';

interface OgTagsProps {
  url: string;
  title: string;
  desc?: string;
}

const OgTags = ({ url, title, desc }: OgTagsProps) => {
  const { locale } = useContext(MarketContext);

  return (
    <Head>
      <meta property="og:title" content={`${title} - Spotify`} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={locale.replace('-', '_')} />
      {desc && <meta property="og:description" content={desc} />}
      <meta property="og:site_name" content="Spotify" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${WEBSITE_CDN}/open-graph-default.png`} />
    </Head>
  );
};

export default OgTags;
